import React from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { useEffect, useMedia } from 'sb-hooks'

import Mobile from './Mobile/Mobile'
import ExceptMobile from './ExceptMobile/ExceptMobile'


const InviteFriendBlock = ({ page, withLink }) => {
  const { isMobile } = useMedia()

  useEffect(() => {
    actions.models.me.getReferralCodes()
  }, [])

  return React.createElement(isMobile ? Mobile : ExceptMobile, {
    page,
    withLink,
  })
}


InviteFriendBlock.propTypes = {
  page: PropTypes.string.isRequired,
  withLink: PropTypes.bool,
}

export default React.memo(InviteFriendBlock)
